export const initialShiftRecordFilterState = () => ({
  startDate: null,
  endDate: null,
  searchType: "stationCode",
  cashiers: {
    value: [],
    isAll: true,
  },
  page: 1,
  perPage: 10,
});
